import {
  Binding,
  GraphObject,
  InputEvent,
  Link,
  Panel,
  Shape,
  TextBlock,
} from 'gojs';

import {promptFont} from 'src/util/gojs/styles/fonts';
import {
  COLOR_EXTRACTED_86,
  COLOR_EXTRACTED_88,
  COLOR_EXTRACTED_89,
  COLOR_EXTRACTED_91,
} from 'src/styles/colors';

import {highlightConnections} from './events';

export type LinkClickedEvent = {
  fromId: string,
  toId: string,
}

const {make} = GraphObject;

// const EDGE_COLOR = COLOR_EXTRACTED_90;
const EDGE_HIGHLIGHT_COLOR = COLOR_EXTRACTED_88;
const EDGE_SELECT_COLOR = COLOR_EXTRACTED_86;
const EDGE_COLOR = COLOR_EXTRACTED_89;

const SEGMENT_CONFIG = {segmentIndex: NaN, segmentFraction: 0.5};

export const makeCommonLinkConfig = ({onLinkClicked}: {onLinkClicked?: (_: LinkClickedEvent) => void }) => [
  make(
      Shape,
      {
        strokeWidth: 2,
        fill: EDGE_COLOR,
        click: handleLinkClick,
      },

      new Binding('stroke', 'isHighlighted', function(h) {
        return h ? EDGE_HIGHLIGHT_COLOR : EDGE_COLOR;
      }).ofObject(),
      new Binding('stroke', 'isSelected', function(h) {
        return h ? EDGE_SELECT_COLOR : EDGE_COLOR;
      }).ofObject(),
      new Binding('fill', 'isSelected', function(h) {
        return h ? EDGE_SELECT_COLOR : EDGE_COLOR;
      }).ofObject(),
  ),
  make(
      Shape,
      {
        scale: 1,
        toArrow: 'Triangle',
        segmentIndex: 1,
        segmentFraction: 1,
        strokeWidth: 2,
        fill: EDGE_COLOR,
      },
      new Binding('stroke', 'isHighlighted', function(h) {
        return h ? EDGE_HIGHLIGHT_COLOR : EDGE_COLOR;
      }).ofObject(),
      new Binding('fill', 'isHighlighted', function(h) {
        return h ? EDGE_HIGHLIGHT_COLOR : EDGE_COLOR;
      }).ofObject(),
      new Binding('stroke', 'isSelected', function(h) {
        return h ? EDGE_SELECT_COLOR : EDGE_COLOR;
      }).ofObject(),
      new Binding('fill', 'isSelected', function(h) {
        return h ? EDGE_SELECT_COLOR : EDGE_COLOR;
      }).ofObject(),
  ),
  make(
      Panel,
      Panel.Auto,
      {
        // segmentOrientation: Link.OrientUpright,
      },
      make(
          Shape,
          'rectangle',
          {
            strokeWidth: 1,
            fill: 'white',
            stroke: EDGE_COLOR,
            height: 20,
            margin: 0,
            click: (_e: InputEvent, graphObject: GraphObject) => {
              const link = graphObject as go.Link;
              const fromId = link.fromNode?.data.id;
              const toId = link.toNode?.data.id;
              if (onLinkClicked && fromId && toId) {
                onLinkClicked({
                  fromId,
                  toId,
                });
              }
            },
            ...SEGMENT_CONFIG,
          },
          new Binding('stroke', 'isSelected', function(h) {
            return h ? EDGE_SELECT_COLOR : EDGE_COLOR;
          }).ofObject(),
          new Binding('width', 'data', ({count}) => {
            if (('' + count).length > 4) {
              return 50;
            } else {
              return 35;
            }
          }),
      ),
      make(
          TextBlock,
          'count',
          {
            textAlign: 'center',
            font: `bold ${promptFont(1)}`,
            stroke: COLOR_EXTRACTED_91,
          },
          new Binding('text', 'data', ({count}) => {
            if (('' + count).length > 4) {
              return count.toExponential();
            } else {
              return count;
            }
          }),
      ),
  ),
];

const handleLinkClick = (_e: InputEvent, graphObject: GraphObject) => {
  if (!(graphObject instanceof Link)) {
    return;
  }

  highlightConnections(graphObject);
};
